import React from 'react';
import { NetInfoStateType } from "@react-native-community/netinfo";
import {
    getAppVersion, getBrand, getBuildId, getDeviceId, getNetInfo,
    getProduct, getSystemName, getSystemVersion, getUserAgent
} from "DeviceUtils";
import { getManufacturer } from 'react-native-device-info';

type SystemInfo = Partial<{
    manufacturer: string,
    ipAddress: string | null,
    deviceId: string,
    deviceType: string,
    model: string,
    brand: string,
    product: string,
    version: string,
    systemName: string,
    systemVersion: string,
    buildNumber: string,
    buildId: string,
    serialNumber: string,
    firstInstallTime: number,
    userAgent: string,
}>

export class SystemInfoHelper {
    private systemInfo: SystemInfo | null = null;

    private getDeviceSystemInfo = async (device?: any) => {
        let ipAddress: string | null = null;
        const netInfo = await getNetInfo();
        if (netInfo.type === NetInfoStateType['wifi'] || netInfo.type === NetInfoStateType['ethernet']) {
            ipAddress = netInfo.details.ipAddress
        };
        return {
            manufacturer: getBrand(),
            model: getDeviceId(),
            year: '',
            devicePlatform: getSystemName(),
            platformVersion: getSystemVersion(),
            firmware: await getBuildId(),
            userAgent: await getUserAgent(),
            wrapperVersion: getAppVersion(),
            product: await getProduct(),
            brand: await getManufacturer()
        };
    }

    load = async (device?: any) => {
        try {
            this.systemInfo = await this.getDeviceSystemInfo(device);
        } catch {
            console.error('Could not load device system info.');
        }
    }

    get = () => {
        if (!this.systemInfo) {
            console.warn('System info for this device is not loaded yet.');
        }
        return this.systemInfo;
    }
}

const SystemInfo = new SystemInfoHelper();
export default SystemInfo;